export enum OENLockedState {
  LOCKED,
  UNLOCKED,
  NONE,
}
